// Omschrijving uit de Outlook-agenda (Airtable-veld Description) leesbaar maken.
// De meeste draaidagen hebben alleen het lege sjabloon ("Call:", "Locatie:", "> Vanuit klant:",
// "Veiligheidskleding:____") — die regels tonen we niet. Een Teams-uitnodiging onderaan ook niet.

const LEEG_LABEL = /^\s*>?\s*[\p{L}\d][\p{L}\d /&()\-.]*:[\s_]*$/u;   // "Call:", "> Vanuit klant:", "Kleding:____"
const STREEP = /^[\s_\-=]{8,}$/;                                      // scheidingslijn van Teams/Outlook
// Alleen de uitnodigingsfooter zelf: de volledige kopregel of de join-link (Codex r1/r2),
// niet elke zin waarin Teams voorkomt.
const TEAMS = /^\s*(Microsoft Teams[- ](vergadering|meeting)|Deelnemen op uw computer.*|Join on your computer.*)\s*$|teams\.microsoft\.com\/l\/meetup-join/i;

export function agendaOmschrijving(tekst) {
  const regels = String(tekst || '').replace(/\r/g, '').split('\n');
  const uit = [];
  for (const regel of regels) {
    if (TEAMS.test(regel)) break;               // vanaf de Teams-uitnodiging is het ruis
    if (STREEP.test(regel) || LEEG_LABEL.test(regel)) continue;
    const r = regel.replace(/\s+$/, '');
    if (!r.trim()) {
      if (uit.length && uit[uit.length - 1] !== '') uit.push('');
      continue;
    }
    uit.push(r);
  }
  while (uit.length && uit[uit.length - 1] === '') uit.pop();
  return uit.length ? uit.join('\n') : '';
}
